import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LANGUAGE } from '@src/constants';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';

const useTranscriptAudioModels = () => {
  const { getFeatureValue } = useFeatureFlags();
  const { user } = useSelector((state) => state.auth);
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const cfg = getFeatureValue(FEATURE_KEYS.TRANSCRIPT_AUDIO_MODELS, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const models = useMemo(() => {
    if (!Array.isArray(cfg)) return [];
    return cfg.filter(
      (m) => m?.model && (m.description?.en || m.description?.vi),
    );
  }, [cfg]);

  const getDescription = useCallback(
    (model) => {
      const description = model?.description || {};
      if (currentLang === LANGUAGE.EN) {
        return description.en || description.vi || '';
      }
      return description.vi || description.en || '';
    },
    [currentLang],
  );

  return { models, getDescription };
};

export default useTranscriptAudioModels;
